// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"91c2e14c","977":"51350779"}[chunkId] + ".chunk.js";
};